/**
 * Created by Bob.Gear on 11/03/14.
 */

// //          if (!Array.prototype.objectPresent) {
// Array.prototype.objectPresent = function (item, comparisonField) {
//   var len = this.length;

//   for (var i = 0; i < len; i++) {
//     if (this[i][comparisonField] == item[comparisonField]) {
//       return true;
//     }
//   }

//   return false;
// }

// //          }
//------------------------------------------------------------------------
//  contractorsFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('contractorsHierachyFilterController', ['$scope', '$http', '$timeout', 'searchService',
      function ($scope, $http, $timeout, searchService) {
        $scope.componentName = "contractorsHierachyFilter";


        var objectPresent = function (array, item, comparisonField) {
          var len = array.length;

          for (var i = 0; i < len; i++) {
            if (array[i][comparisonField] == item[comparisonField]) {
              return true;
            }
          }

          return false;
        };

        $scope.availableContractors = [];

        $scope.getContractors = function (inputValue) {
          if (!inputValue) {
            $scope.availableContractors.length = 0;
            return;
          }


          var q = { contractorName: inputValue};

          // todo: move $http call into a service. Gradually do the same for all filters
          return $http.get('/api/contractornamehierachy', {
            params: {
              limit: 75,
              contractorname: inputValue
            }
          }).then(function (res) {
            // $scope.availableContractors = res.data;

            // set available contractors, filtering out those that
            // have already been selected
            $scope.availableContractors = res.data.filter(function(item){
              if (!$scope.selectedContractors) return true; // selected contractors do not yet exist, so  select all
              //if ($scope.selectedContractors.objectPresent(item, "companyID")) {
              if (objectPresent($scope.selectedContractors, item, "companyID")) {
                // object has already been selected; false omits it from the returned list
                return false;
              }
              else{
                return true;
              }
            });

          });
        };


        $scope.addCheckedItems = function () {
          if(!$scope.selectedContractors) $scope.selectedContractors = [];

          // Add the chosen items to the model by copying fom selectedContractors
          // - they get automatically selected because of the 'initially selected clause
          Array.prototype.push.apply($scope.selectedContractors, $scope.candidateContractors);

          $scope.candidateContractors.length = 0;
          $scope.availableContractors.length = 0;
        };


        $scope.initialiseSelectedContractors = function () {
          if(!$scope.criteria.selectedContractors) return;

          // initialise the selectedContractors by copying from the model
          if (!$scope.selectedContractors) $scope.selectedContractors = [];
          Array.prototype.push.apply($scope.selectedContractors, $scope.criteria.selectedContractors);
        };

        $scope.candidateContractors = [];
        $scope.selectedContractors = [];


        $scope.biddingStatuses = [
          {id:1, name:"Awarded"},
          {id:2, name:"Unsuccessful"},
          {id:3, name:"Bidding"},
          {id:4, name:"Cancelled"}
        ];

        $scope.contractAwardSearch = searchService.queryDef.searchSubject=="Contract Award";

        $scope.resetFilter = function () {
          $scope.candidateContractors.length = 0;
          $scope.availableContractors.length = 0;

          // fully remove the selected contractors key; it is no longer needed
          $scope.criteria.selectedContractors = null;
          delete $scope.criteria.selectedContractors

          // and bidding statuses
          $scope.criteria.selectedBiddingStatuses = null;
          delete $scope.criteria.selectedBiddingStatuses;
        };

        $scope.removeContractorsFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#contractorsHierachyFilter");
        };


        $scope.$watch("candidateContractors.length", function(){
          if(!$scope.candidateContractors) return;

          $scope.candidateContractorCount = $scope.candidateContractors.length;
          $scope.candidateContractorPlural = ($scope.candidateContractorCount === 1) ? "": "s";
        });

        $scope.$watch("criteria.selectedContractors.length", function(){
          if(!$scope.criteria.selectedContractors) return;

          $scope.selectedContractorCount = $scope.criteria.selectedContractors.length;
          $scope.selectedContractorCountPlural = ($scope.selectedContractorCount === 1) ? "" : "s";
        });

        $scope.$watch("criteria.selectedBiddingStatuses.length", function(){
          if(!$scope.criteria.selectedBiddingStatuses) return;

          $scope.selectedBiddingStatusesCount = $scope.criteria.selectedBiddingStatuses.length;
          $scope.biddingStatusesPlural = ($scope.selectedBiddingStatusesCount === 1) ? "" : "s";
        });

        // when the filter starts up, move entries from the model to selected operators
        $scope.initialiseSelectedContractors();
      }])
    .directive('contractorsHierachyFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/contractorsHierachyFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'contractorsHierachyFilterController'
        };
      }]);
//------------------------------------------------------------------------
